import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "candidateTimelinepage"
}
const _hoisted_2 = { class: "timelinecontainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "linIndicator" }, null, -1)
const _hoisted_4 = { class: "date" }
const _hoisted_5 = {
  key: 0,
  class: "bodyContent newRequest"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "first" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Request Created")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "content"
}
const _hoisted_12 = {
  key: 1,
  class: "content"
}
const _hoisted_13 = {
  key: 1,
  class: "bodyContent refereeAdded"
}
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "first" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Referee Added")
const _hoisted_17 = { class: "status" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_19 = { class: "content" }
const _hoisted_20 = {
  key: 2,
  class: "bodyContent completed"
}
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "first" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Referee Completed")
const _hoisted_24 = { class: "status" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_26 = { class: "content" }
const _hoisted_27 = {
  key: 3,
  class: "bodyContent refereeReminded"
}
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "first" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Referee Added")
const _hoisted_31 = { class: "status" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_33 = { class: "content" }
const _hoisted_34 = {
  key: 4,
  class: "bodyContent refereeDeleted"
}
const _hoisted_35 = { class: "title" }
const _hoisted_36 = { class: "first" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Referee Deleted")
const _hoisted_38 = { class: "status" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_40 = { class: "content" }
const _hoisted_41 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_UserAddOutlined = _resolveComponent("UserAddOutlined")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_ClockCircleFilled = _resolveComponent("ClockCircleFilled")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!

  return (_ctx.candidateTimelines)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateTimelines, (timeline) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "singletimeline",
              key: timeline.id
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CalendarOutlined),
                _createTextVNode(" " + _toDisplayString(timeline.created_at), 1)
              ]),
              (timeline.action === 'Reference Created')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_UserAddOutlined),
                        _hoisted_8
                      ]),
                      _hoisted_9
                    ]),
                    _hoisted_10,
                    (timeline.candidate_notify)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(timeline.request_created_by) + " requested " + _toDisplayString(timeline.reference_required) + " references for " + _toDisplayString(timeline.candidate_name) + ". Request email sent to " + _toDisplayString(timeline.candidate_email), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(timeline.request_created_by) + " requested " + _toDisplayString(timeline.reference_required) + " references for " + _toDisplayString(timeline.candidate_name) + " without sending notification. ", 1))
                  ]))
                : _createCommentVNode("", true),
              (timeline.action === 'Referee Added' && timeline.status === 'pending')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_UserAddOutlined),
                        _hoisted_16
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_CheckCircleFilled),
                        _createTextVNode(" " + _toDisplayString(timeline.status), 1)
                      ])
                    ]),
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(timeline.referee_name) + " was added as referee by " + _toDisplayString(timeline.request_created_by) + ". Email sent to " + _toDisplayString(timeline.referee_email), 1)
                  ]))
                : _createCommentVNode("", true),
              (timeline.action === 'Referee Completed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_UserAddOutlined),
                        _hoisted_23
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_CheckCircleFilled),
                        _createTextVNode(" " + _toDisplayString(timeline.status), 1)
                      ])
                    ]),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(timeline.referee_name) + " has completed the referee request for " + _toDisplayString(timeline.candidate_name) + " on " + _toDisplayString(timeline.created_at), 1)
                  ]))
                : _createCommentVNode("", true),
              (timeline.action === 'Referee Added' && timeline.status === 'Reminded')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_UserAddOutlined),
                        _hoisted_30
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ClockCircleFilled),
                        _createTextVNode(_toDisplayString(timeline.status), 1)
                      ])
                    ]),
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(timeline.referee_name) + " was added as referee by " + _toDisplayString(timeline.request_created_by) + ". Email sent to " + _toDisplayString(timeline.referee_email), 1)
                  ]))
                : _createCommentVNode("", true),
              (timeline.action === 'Referee Deleted')
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_UserAddOutlined),
                        _hoisted_37
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_DeleteFilled),
                        _createTextVNode(_toDisplayString(timeline.status), 1)
                      ])
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createTextVNode(_toDisplayString(timeline.referee_name) + " was deleted ", 1),
                      (timeline.request_created_by !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "by " + _toDisplayString(timeline.request_created_by), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" on " + _toDisplayString(timeline.created_at), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}